var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftAlingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 0.5C1.66421 0.5 2 0.835786 2 1.25V20.75C2 21.1642 1.66421 21.5 1.25 21.5C0.835786 21.5 0.5 21.1642 0.5 20.75V1.25C0.5 0.835786 0.835786 0.5 1.25 0.5Z",
    fill: "#112299"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 6.125C3.5 5.50368 4.05964 5 4.75 5H17.25C17.9404 5 18.5 5.50368 18.5 6.125V8.375C18.5 8.99632 17.9404 9.5 17.25 9.5H4.75C4.05964 9.5 3.5 8.99632 3.5 8.375V6.125Z",
    fill: "#112299"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12.5C4.17157 12.5 3.5 13.0037 3.5 13.625V15.875C3.5 16.4963 4.17157 17 5 17H20C20.8284 17 21.5 16.4963 21.5 15.875V13.625C21.5 13.0037 20.8284 12.5 20 12.5H5Z",
    fill: "#112299"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftAlingIcon);
export default __webpack_public_path__ + "static/media/left-aling-icon.dfb07afdf5d3b3cffa0cb70e7645dbd7.svg";
export { ForwardRef as ReactComponent };